var map = {
	"./block-card-ng/data.json": [
		10848,
		848
	],
	"./block-card/data.json": [
		60978,
		978
	],
	"./business/data.json": [
		63770,
		3770
	],
	"./debit/data.json": [
		57924,
		7924
	],
	"./fees/data.json": [
		55891,
		5891
	],
	"./help/data.json": [
		90033,
		33
	],
	"./home-phone/data.json": [
		52074,
		906
	],
	"./home-ring/data.json": [
		8342,
		7881
	],
	"./invest-money/data.json": [
		4256,
		4256
	],
	"./money-manage-ng/data.json": [
		28006,
		8006
	],
	"./money-manage-uk/data.json": [
		58823,
		8823
	],
	"./money-manage/data.json": [
		92652,
		2652
	],
	"./ng-phone/data.json": [
		24706,
		906
	],
	"./ng-ring/data.json": [
		32398,
		979
	],
	"./save-money/data.json": [
		18636,
		8636
	],
	"./send-money/data.json": [
		30005,
		5
	],
	"./send-uk/data.json": [
		43789,
		3789
	],
	"./simpler-life/data.json": [
		32531,
		2531
	],
	"./spend-money/data.json": [
		37165,
		7165
	],
	"./spend/data.json": [
		32834,
		2834
	],
	"./transfer-uk/data.json": [
		38776,
		6395
	],
	"./uk-phone/data.json": [
		1735,
		9153
	],
	"./virtual-cards/data.json": [
		81161,
		1161
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 96601;
module.exports = webpackAsyncContext;